import React from 'react';

import UserData from '@/types/User/UserData';

import { useGetUserDivisionsQuery } from '../../api/use-get-user-divisions.query';
import { UserPermissionsTable } from './user-permissions.table';

type Props = {
  user?: UserData | null;
};

export const UserPermissionsDivisionsTable = ({ user }: Props) => {
  return <UserPermissionsTable query={useGetUserDivisionsQuery} user={user} />;
};
